import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import USE_MERCURE from '~/const/mercure';
export default {
  name: 'LoginRegister',
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    loginUrl() {
      if (USE_MERCURE(this.locale.iso)) {
        return "/".concat(this.locale.market, "/").concat(this.locale.language, "/login?redirectUrl=").concat(this.$route.path);
      }

      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/account/signin?return_url=").concat(window.location.pathname);
    },

    signupUrl() {
      if (USE_MERCURE(this.locale.iso)) {
        return "/".concat(this.locale.market, "/").concat(this.locale.language, "/signup?redirectUrl=").concat(this.$route.path);
      }

      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/account/signin?return_url=").concat(window.location.pathname);
    }

  }),
  methods: {
    closeLayer() {
      this.$emit('close');
    },

    tracking(_ref) {
      var {
        category,
        action,
        label
      } = _ref;
      return {
        data: {
          event_category: category,
          event_action: action,
          event_label: label
        }
      };
    }

  }
};